import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import tenantsService from '@/tenants/services/tenants-service'

@Component
export default class FeedbackDialog extends Vue {
    @Prop()
    private value!: boolean

    private text = ''
    private confirmation = false

    @Watch('value')
    private valueChanged(newValue: boolean) {
        if (newValue) {
            this.confirmation = false
        }
    }

    private close() {
        this.$emit('close')
    }

    private async send() {
        await tenantsService.sendFeedback(this.text)
        this.$emit('close')
        this.confirmation = true
        this.text = ''
    }
}
